import { render, staticRenderFns } from "./FeedbackRequests.vue?vue&type=template&id=5c0e1a8e"
import script from "./FeedbackRequests.vue?vue&type=script&lang=js"
export * from "./FeedbackRequests.vue?vue&type=script&lang=js"
import style0 from "./FeedbackRequests.vue?vue&type=style&index=0&id=5c0e1a8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports